import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';

const GtmRouteListener = () => {
	const location = useLocation();
	const previousUrlRef = useRef<string | null>(null);
	const previousHistoryStateRef = useRef<any>(null);

	function generateKey() {
		return Math.random().toString(36).substr(2, 9);
	}

	useEffect(() => {
		window.dataLayer = window.dataLayer || [];

		const currentUrl = location.pathname + location.search;
		const previousUrl = previousUrlRef.current || document.referrer || '';

		const newHistoryState = {
			usr: null,
			key: generateKey(),
		};

		const oldHistoryState = previousHistoryStateRef.current || {
			usr: null,
			key: '',
		};

		previousUrlRef.current = currentUrl;
		previousHistoryStateRef.current = newHistoryState;

		const currentUrlFragment = location.hash;

		let previousFragment = '';
		try {
			const previousUrlObj = new URL(previousUrl);
			previousFragment = previousUrlObj.hash;
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
		} catch (error) {
			console.warn('Invalid previous URL', previousUrl);
		}

		window.dataLayer.push({
			event: 'gtm.historyChange',
			'gtm.historyChangeSource': 'react-router',
			'gtm.newHistoryState': newHistoryState,
			'gtm.newUrl': currentUrl,
			'gtm.newUrlFragment': currentUrlFragment,
			'gtm.oldUrl': previousUrl,
			'gtm.oldHistoryState': oldHistoryState,
			'gtm.oldFragment': previousFragment,
		});
	}, [location]);

	return null;
};

export default GtmRouteListener;
